export const OPEN_PAYMENT_MODAL = 'open_payment_modal';
export const CLOSE_PAYMENT_MODAL = 'close_payment_modal';
export const SHOW_LOADER = 'show_loader';
export const HIDE_LOADER = 'hide_loader';
export const SELECT_PLAN = 'select_plan';
export const SELECTED_PLAN_INDEX = 'selected_plan_index';
export const OPEN_NEW_CARD_MODAL = 'open_new_card_modal';
export const CLOSE_NEW_CARD_MODAL = 'close_new_card_modal';

